var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcademyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-365 -396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1893 1.69449 1.85188 32.644",
    stroke: "#0098FF",
    strokeWidth: 5.02318,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.22282 31.3715 36.0765 63.2251",
    stroke: "#0098FF",
    strokeWidth: 5.02318,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6007 2.01597 45.1919 19.6105",
    stroke: "#0098FF",
    strokeWidth: 5.02318,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9755 16.6703 32.058 31.3715",
    stroke: "#0098FF",
    strokeWidth: 5.02318,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0889 32.2053 32.567 15.6824",
    stroke: "#00FFCE",
    strokeWidth: 5.35806,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6847 46.6118 18.2208 29.5999",
    stroke: "#00FFCE",
    strokeWidth: 5.35806,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5402 46.3104 53.5237 22.6981",
    stroke: "#00FFCE",
    strokeWidth: 5.35806,
    strokeMiterlimit: 10,
    fill: "none",
    transform: "matrix(1.00686 0 0 1 365.046 396)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademyIcon);
export default __webpack_public_path__ + "static/media/academyIcon.f9973470558f1743c93501803fdd3fdc.svg";
export { ForwardRef as ReactComponent };